<!--  -->
<template>
<div class='' v-show="show" style="height:90%">
  <div style="margin-bottom:10px;display:flex;justify-content:flex-start;">
  <el-button  type="success" icon="el-icon-plus" @click="addData()" plain>添加数据</el-button>
    </div>
    <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="deletedIds()"
                title="确定删除该组数据吗？">
          <el-button style="margin-bottom:10px" v-show="ids.length>0"   type="danger" icon="el-icon-delete" slot="reference" plain>删除该组数据</el-button>
    </el-popconfirm>
      <el-table
        :data="tableData.list"
        @selection-change="handleSelectionChange"
        @filter-change="filterMethod"
        @sort-change="sortChange"
        style="width: 100%;height:85%;overflow: scroll;">
        <el-table-column
              type="selection"
              width="55">
        </el-table-column>
        <el-table-column
          label="背景图一"
          width="180">
          <template slot-scope="scope">
            <el-image style="width: 150px; height: 100px" :src="scope.row.backImgOne" fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="背景图二"
          width="180">
          <template slot-scope="scope">
            <el-image style="width: 150px; height: 100px" :src="scope.row.backImgTwo" fit="scale-down"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="年龄分类"
          :filters="[{text:'小童',value:1},{text:'大童',value:2}]"
          filter-placement="bottom-end"
          :filter-multiple="false"
          column-key="corType"
          width="180">
          <template slot-scope="scope">
            <el-tag
          :type="scope.row.type == 1 ? 'primary' : 'success'"
          disable-transitions>{{scope.row.type==1?'小童':'大童'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="classify"
          label="形象分类"
          :filters="fclassifys"
          filter-placement="bottom-end"
          :filter-multiple="false"
          column-key="classify"
          width="180">
        </el-table-column>
        <el-table-column
          prop="ifshow"
          label="是否展示"
          :filters="[{text:'展示',value:true},{text:'未展示',value:false}]"
          filter-placement="bottom-end"
          :filter-multiple="false"
          column-key="ifshow"
          width="180">
          <template slot-scope="scope">
             <el-switch
              :value="scope.row.ifshow"
              @change="changeDisplay(scope.row,scope.$index)"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="num"
          label="浏览次数"
          width="180">
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="发布时间"
          sortable
          width="180">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              style="margin-right:10px"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
           <el-popconfirm
                confirm-button-text='确定'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="handleDelete(scope.$index, scope.row)"
                title="确定删除吗？">
                <el-button
                size="mini"
                type="danger"
                slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:10px"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="tableData.currPage"
        :total="tableData.totalCount"
        :page-size="tableData.pageSize">
      </el-pagination>
      <el-dialog title="编辑" :visible.sync="dialogFormVisible" width="30%" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" >
          <el-form-item style="display:none">
          <el-input v-model="form.id" clearable></el-input>
          </el-form-item>
          <el-form-item label="分类图片一" label-width="120px" prop="backImgOne">
            <s-upload-img :getImageUrl="getBackImgOne" :url="form.backImgOne"></s-upload-img>
          </el-form-item>
          <el-form-item label="分类图片二" label-width="120px" prop="backImgTwo">
            <s-upload-img :getImageUrl="getBackImgTwo" :url="form.backImgTwo"></s-upload-img>
          </el-form-item>
          <el-form-item label="选择分类" label-width="120px" prop="classify">
          <el-select v-model="form.classify"  placeholder="请选择分类">
            <el-option
              v-for="item in classifys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="选择年龄分类" label-width="120px" prop="classify">
          <el-select v-model="form.type"  placeholder="请选择分类">
            <el-option key="1" label="小童" :value="1"></el-option>
            <el-option key="2" label="大童" :value="2"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="是否展示" label-width="120px">
            <el-switch
              v-model="form.ifshow"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit('form')">{{(form.id==""||form.id==undefined)?'添加信息':'更新信息'}}</el-button>
        </div>
      </el-dialog>
</div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import sUploadImg from '@/components/SingleImgUpload'
import {insert,update,query,queryList,deleted,deletedIds} from '@/api/admin/corporateImageList.js'
import {querySortList} from '@/api/admin/corporateImageSort.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {sUploadImg},
data() {
//这里存放数据
return {
dialogFormVisible:false,
show:false,
classifys:[],
rules:{
  backImgOne:{required:true,message:"背景图一不能为空",trigger:'blur'},
  backImgTwo:{required:true,message:"背景图二不能为空",trigger:'blur'},
  classify:{required:true,message:"请选择一个分类",trigger:'blur'}
},
condition:{
  current:1,
  size:5,
  title:"",
  corType:0,
  classify:"all",
  createTimeSort:"desc",
  ifDisplay:2
},
tableData:{
  totalCount:1,
  pageSize:1,
  totalPage:1,
  currPage:1,
  list:[]
},
form:{
  id:"",
  backImgOne:"",
  backImgTwo:"",
  ifshow:false,
  classify:"",
  type:1
},
ids:[]
};
},
//监听属性 类似于data概念
computed: {
  fclassifys(){
    var cs = this.classifys
    var fcs = []
    cs.forEach(c=>{
      fcs.push({text:c.name,value:c.id})
    })
    return fcs;
  }
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  filterMethod(value){
        var _this = this
        console.log("CORtYPE",value)
        this.condition.current=1
        if(value.ifshow){
           if(value.ifshow[0] == true){
            this.condition.ifDisplay=1
           }else if(value.ifshow[0] == false){
            this.condition.ifDisplay=0
           }else{
            this.condition.ifDisplay=2
           }
        }
        if(value.classify){
          if(value.classify[0]!=null){
            this.condition.classify=value.classify[0]
          }else{
          this.condition.classify="all"
          }       
        }

        if(value.corType){
          if(value.corType[0]!=null){
            this.condition.corType=value.corType[0]
          }else{
            this.condition.corType=0
          }
        }
        queryList(_this.condition).then(({data})=>{
            _this.tableData=data
          },()=>{_this.tableData.list=[]})
      },
      sortChange(value){
          var _this = this
          this.condition.current=1
          if(value.prop=="createTime"){
            if(value.order=="descending"){
              _this.condition.createTimeSort="desc"
            }else if(value.order=="ascending"){
              _this.condition.createTimeSort="asc"
            }else{
              _this.condition.createTimeSort="desc"
            }
          }
          queryList(_this.condition).then(({data})=>{
            _this.tableData=data
          },()=>{_this.tableData.list=[]})
    },
  deletedIds(){
        var _this  = this
        deletedIds(_this.ids,_this.condition).then(({data})=>{
          _this.tableData = data
          _this.$message.success("该组数据删除成功!")
        },()=>{_this.tableData.list=[]})
      },
  handleSelectionChange(val) {
        var ids = []
        for(var i=0;i<val.length;i++){
          ids.push(val[i].id)
        }
        this.ids=ids
  },
  filterType(value,row){
    return row.type===value
  },
  filterIfShow(value,row){
    return row.ifshow===value
  },
  filterClassify(value, row){
    return row.classify===value
  },
  addData(){
    this.dialogFormVisible=true;
    // this.form ={id:"",backImgOne:"",backImgTwo:"",classify:"",ifshow:false}
    this.form.id="",
    this.form.backImgOne="",
    this.form.backImgTwo=""
  },
  handleDelete(index){
    var _this = this
    deleted(_this.tableData.list[index]).then(()=>{
      if((_this.tableData.totalCount%_this.condition.size==1)&&_this.tableData.totalCount!=1&&_this.condition.current==_this.tableData.totalPage){
        _this.condition.current=_this.condition.current-1
      }
      _this.$message.success("删除成功!")
      queryList(_this.condition).then(({data})=>{
        _this.tableData=data
      },()=>{_this.tableData.list=[]})
    })
  },
  handleCurrentChange(val){
    var _this =this
    _this.condition.current = val
    queryList(_this.condition).then(({data})=>{
    _this.tableData=data
   })
  },
  submit(name){
    var _this = this
    this.$refs[name].validate((valid)=>{
      if(valid){
        if(!(_this.form.id!=null&&_this.form.id!=""&&_this.form.id!=undefined)){
             insert(_this.form).then(()=>{
              this.$message.success("添加成功")
              _this.dialogFormVisible=false
              queryList(_this.condition).then(({data})=>{
                if(data!=null){
                _this.tableData = data
                }
              })
             })
        }else{
             update(_this.form).then(()=>{
              this.$message.success("更新成功")
                queryList(_this.condition).then(({data})=>{
                  if(data!=null){
                  _this.tableData = data
                  }
                })
             })
        }
      }else{
        this.$message.info("请填写完整信息")
      }
    })
  },
  handleEdit(index, row){
    var _this =this
    query({id:row.id}).then(({data})=>{
      let {id,backImgOne,backImgTwo,ifshow,classify,type}=data
      _this.form.id=id
      _this.form.backImgOne=backImgOne
      _this.form.backImgTwo=backImgTwo
      _this.form.ifshow=ifshow
      _this.form.classify=classify
      _this.form.type=type
    })
    this.dialogFormVisible=true
  },
  changeDisplay(row,index){
     var _this = this
      update({id:row.id,ifshow:!row.ifshow}).then(()=>{
          _this.$message.success("更新成功!")
      })
      this.tableData.list[index].ifshow=!row.ifshow
  },
  getBackImgOne(val){
    this.form.backImgOne=val
  },
  getBackImgTwo(val){
    this.form.backImgTwo=val
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show=true
 var _this = this
 queryList(_this.condition).then(({data})=>{
  if(data!=null){
  _this.tableData = data
  }
 })
 querySortList().then(({data})=>{
  _this.classifys=data
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类

</style>